const planOperation = {
  appCode: {
    development: '1675742171034476546',
    fat: '1675742171034476546',
    test: '1675742171034476546',
    production: '1675742171034476546'
  }[process.env.VUE_APP_ENV_NAME],
  clientId: {
    development: 'app_engineer_plan',
    fat: 'app_engineer_plan',
    test: 'app_engineer_plan',
    production: 'app_engineer_plan'
  }[process.env.VUE_APP_ENV_NAME],
  js: './plan-operation/main.js'
};

export default planOperation;
